import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";
import type { MerchantDto, MerchantFilter } from "@/features/merchant/api/dto";

/**
 * Liste paginée des marchands (`POST /Merchants/all` — guide §4.2 : les
 * listes sont en POST). Lecture authentifiée : `mutateData` en queryFn.
 */
export const useMerchants = (
  params: ListRequest<MerchantFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.MERCHANTS_LIST(params),
    queryFn: () =>
      mutateData({
        url: merchantEndpoints.merchants.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<MerchantDto>>,
    enabled,
  });
